import { useApi } from '@/api';
import { KpiCard, Page, PageSkeleton, WalletCard } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex, Heading } from '@blockanalitica/ui';
import { useParams } from 'react-router-dom';
import DSRDepositorEventsTable from './DSRDepositorEventsTable';
import HistoricTabs from './HistoricTabs';

export default function DSRDespositorEventsPage() {
  const { walletAddress } = useParams();
  const [data, error] = useApi({
    url: `/save/dsr/depositors/${walletAddress}/`,
    queryParams: {
      days_ago: 1
    }
  });

  if (error) {
    throw error;
  }
  if (data) {
    return (
      <Page title={<Heading size="1">Supplier</Heading>}>
        <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
          <WalletCard address={data.wallet_address} />
          <KpiCard
            title="Balance"
            variant="dai"
            data={data}
            field="total_balance"
            options={{
              currency: tokensMapping('DAI'),
              notation: 'compact',
              valueOptions: { currencyValueOptions: { iconSize: '4' } }
            }}
          />
        </Flex>
        <HistoricTabs walletAddress={data.wallet_address} />
        <DSRDepositorEventsTable walletAddress={walletAddress} />
      </Page>
    );
  }
  return <PageSkeleton />;
}
